/**
 * @generated SignedSource<<d5d69b8070b8b9b67bedd6116c24c571>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type StudentSkillAssessmentDailySnapshotFilterInput = {
  classIds?: ReadonlyArray<string> | null | undefined;
  gradeLevelIds?: ReadonlyArray<string> | null | undefined;
  isActive?: boolean | null | undefined;
  reportDate: any;
  siteIds?: ReadonlyArray<string> | null | undefined;
  targetGroupIds?: ReadonlyArray<string> | null | undefined;
};
export type DashboardStudentsListDailyQuery$variables = {
  filter: StudentSkillAssessmentDailySnapshotFilterInput;
  score?: number | null | undefined;
  skip?: boolean | null | undefined;
};
export type DashboardStudentsListDailyQuery$data = {
  readonly studentsSkillAssessmentsDailySnapshotDetail?: ReadonlyArray<{
    readonly skills: ReadonlyArray<{
      readonly code: string | null | undefined;
      readonly name: string | null | undefined;
    }>;
    readonly student: {
      readonly firstName: string | null | undefined;
      readonly id: string;
      readonly lastName: string | null | undefined;
      readonly publicUserId: string | null | undefined;
    } | null | undefined;
  }>;
};
export type DashboardStudentsListDailyQuery = {
  response: DashboardStudentsListDailyQuery$data;
  variables: DashboardStudentsListDailyQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "score"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  },
  {
    "kind": "Variable",
    "name": "score",
    "variableName": "score"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Student",
  "kind": "LinkedField",
  "name": "student",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publicUserId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardStudentsListDailyQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "TeacherDashboardSnapshotDetail",
            "kind": "LinkedField",
            "name": "studentsSkillAssessmentsDailySnapshotDetail",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SkillNode",
                "kind": "LinkedField",
                "name": "skills",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DashboardStudentsListDailyQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "TeacherDashboardSnapshotDetail",
            "kind": "LinkedField",
            "name": "studentsSkillAssessmentsDailySnapshotDetail",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SkillNode",
                "kind": "LinkedField",
                "name": "skills",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "cbe4b10857445da3784e35b87a5453f9",
    "id": null,
    "metadata": {},
    "name": "DashboardStudentsListDailyQuery",
    "operationKind": "query",
    "text": "query DashboardStudentsListDailyQuery(\n  $filter: StudentSkillAssessmentDailySnapshotFilterInput!\n  $score: Int = null\n  $skip: Boolean = false\n) {\n  studentsSkillAssessmentsDailySnapshotDetail(filter: $filter, score: $score) @skip(if: $skip) {\n    student {\n      firstName\n      lastName\n      id\n      publicUserId\n    }\n    skills {\n      name\n      code\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1970e308687f3c1a9f331e5651e9475c";

export default node;
